import * as types from "../actions/actionTypes";

// Sound sync: the host's phone broadcasts the current song and verse as near-ultrasonic
// tones; participants' phones listen (see sound/ and actions/soundSyncActions.js).
export const initialSoundSyncState = {
  enabled: false,
  status: "off", // off | starting | broadcasting | listening | interrupted | denied | unsupported | error
  role: null, // "host" | "participant" while enabled
  sessionCode: null, // the session the engine was started for; a change turns sync off
  enabledAt: null, // when the engine started, for "nothing heard yet" on participants
  lastHeard: null, // when a message was last decoded (participants)
  signal: 0, // participants: the strongest tone above the noise floor (dB), a few times a second
  error: null, // why it could not start, or what cannot be sent
};

export default function soundSyncReducer(state = initialSoundSyncState, action) {
  switch (action.type) {
    case types.SOUND_SYNC_SET:
      return { ...state, ...action.changes };

    default:
      return state;
  }
}
